"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * This is the public interface of @angular-redux/store. It wraps the global
 * redux store and adds a few other add on methods. It's what you'll inject
 * into your Angular application as a service.
 */
var NgRedux = (function () {
    function NgRedux() {
    }
    /** @hidden, @deprecated */
    NgRedux.instance = undefined;
    return NgRedux;
}());
exports.NgRedux = NgRedux;
//# sourceMappingURL=ng-redux.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/admin/Documents/Visual Studio 2017/Projects/VanzAngularEcommerce/~/@angular-redux/store/lib/src/components/ng-redux.js
// module id = ../../../../@angular-redux/store/lib/src/components/ng-redux.js
// module chunks = 3